import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import i18next from 'i18next';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { config as i18nextConfig } from './i18n/config';

i18next.init(i18nextConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <I18nextProvider i18n={i18next}>
          <BrowserRouter>
              <App />
          </BrowserRouter>
      </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
